import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { signOutUser } from '../api/auth.api';
import recipeLogo from '../imgs/foodrecipe-logo.png';
import {MdClose} from 'react-icons/md';

function Sidebar({ links, closeSidebar }) {
    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <div className='sidebar'>
            <div className="close_sidebar_icon">
                <MdClose size={30}/>
            </div>
            <div className="logo_wrapper">
                <img src={recipeLogo} alt="" className="logo_image" />
            </div>
            {
                [links[0], links[1], links[5]].map((link, index) => (
                    <Link to={link.path}
                        className={location.pathname === link.path ? "sidebar-link active" : "sidebar-link"}
                        key={index}
                        onClick={closeSidebar}
                    >
                        <FontAwesomeIcon icon={link.icon} />
                        <span>{link.name}</span>
                    </Link>
                ))
            }
            {
                currentUser ?
                    <>
                        <Link to={links[4].path}
                            className={location.pathname === links[4].path ? "sidebar-link active" : "sidebar-link"}
                            onClick={closeSidebar}
                        >
                            <FontAwesomeIcon icon={links[4].icon} />
                            <span>{links[4].name}</span>
                        </Link>
                        <div className="sidebar-link"
                            onClick={() => {
                                signOutUser(dispatch, navigate)
                                closeSidebar()
                            }}
                        >
                            <FontAwesomeIcon icon={faSignOutAlt} />
                            <span>Sign out</span>
                        </div>
                    </>
                    :
                    [links[2], links[3]].map((link, index) => (
                        <Link to={link.path}
                            className={location.pathname === link.path ? "sidebar-link active" : "sidebar-link"}
                            key={index}
                            onClick={closeSidebar}
                        >
                            <FontAwesomeIcon icon={link.icon} />
                            <span>{link.name}</span>
                        </Link>
                    ))
            }
        </div>
    );
}

export default Sidebar;